import React, { Component } from 'react';
import Event from './Event.js'
import {db} from './../firebase/firebase.js'
import {colors} from './../utils/constants.js'

const photoStyle = {
	height : '200px', 
	width : '200px',
	margin:'auto',
	marginTop:'50px'
	
}
const Container = {
	display: 'flex',
}

class Profile extends Component {
	constructor(props) {
		super(props)

		this.state = {
			/* events: props.events */
			// events: [
			// 	{
			// 		name: "Free food at SDHACKS",
			// 		location: "RIMAC Arena",
			// 		upvotes: 0,
			// 		description: "Hackathon, giving out food!",
			// 		posts: [{fake: "a", fake: "d", fake: "b"}]
			// 	},
			// 	{
			// 		name: "Free food at HDH Wellness",
			// 		location: "Marshall Field",
			// 		upvotes: 0,
			// 		description: "Music /Food!",
			// 		posts: [{fake: "a", fake: "d", fake: "b"}]
			// 	}
			// ]
		}
	}

	componentDidMount() {
		db.collection("users")
			.where("uid", "==", this.props.uid)
			.limit(1).get().then(snapshot => {
      			snapshot.forEach(doc => {
      				let data = doc.data()
      				this.setState(data)
      				console.log(this.state)
      		    })
		    })
		    .catch(err => {
		      console.log('Error getting documents', err);
		    });
	}

	render() {
		let upvotes = (this.state.upvotes) ? this.state.upvotes : 23
		return (
			<div className = "Profile">
				<div className = "tableMain">
						<img style = {photoStyle} 
						src={this.state.photo}
						className = "userPhoto"/>

					<h1 style={{margin : "auto", marginTop: 15, color: colors.white}}>
						{this.state.name}
					</h1>
					<h2 style={{margin : "auto", marginTop: 25, color: colors.white}}>
						<span>
							<text> {this.state.upvotes + " UPVOTES"}</text>
							{/* <text> {this.state.posts.length()} + " posts" </text> */}
						</span>
					</h2>

					<p style={{margin:"auto"}}> {this.state.posts}</p>	
				</div>
			</div>
		)
	}
}

export default Profile;
